import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "io-grid" }
const _hoisted_2 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "io-bubble input-bubble" }
const _hoisted_5 = { class: "io-bubble output-bubble" }
const _hoisted_6 = {
  key: 0,
  class: "text-body-2 text-grey-darken-2 mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { class: "io-row" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.examples, (example) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            key: example.label,
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: _normalizeClass(["io-card", example.outcome === 'good' ? 'good-card' : 'bad-card']),
                variant: "outlined"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, _toDisplayString(example.label), 1),
                      _createVNode(_component_v_chip, {
                        size: "small",
                        color: example.outcome === 'good' ? 'green-darken-2' : 'red-darken-1',
                        variant: "flat"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(example.outcome === 'good' ? 'Prosocial' : 'Harmful'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_card_subtitle, { class: "text-body-2 text-grey-darken-2 px-4 pb-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Model: " + _toDisplayString(example.model), 1),
                      (example.persona)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[0] || (_cache[0] = _createTextVNode(" (", -1)),
                            (example.personaUrl)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: example.personaUrl,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "persona-link"
                                }, _toDisplayString(example.persona), 9, _hoisted_3))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(example.persona), 1)
                                ], 64)),
                            _cache[1] || (_cache[1] = _createTextVNode(")", -1))
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-caption text-uppercase text-grey-darken-1 mb-1" }, " User input ", -1)),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(example.input), 1),
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-caption text-uppercase text-grey-darken-1 mt-4 mb-1" }, " Model output ", -1)),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(example.output), 1),
                      (example.note)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(example.note), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}